/*
 * The token a mailed link carries, read from `?token=` (stage 4b phase D).
 *
 * Read and nothing more: the pages that use it spend the token only from a
 * button press or a form submit, never on mount, because mail scanners prefetch
 * links and a GET that changed state would let a scanner verify an address or
 * spend a reset link before its owner ever saw it.
 */

import { useLocation } from "react-router";

/** The link's token, or null when the URL carries none. */
export function useLinkToken(): string | null {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token");
  return token && token.length > 0 ? token : null;
}
